import styled from 'styled-components';

import { StyleVars } from 'core/utils/Styles';

import { VariantComponent } from './VariantComponent';

export const VariantComponentStyled = styled(VariantComponent)`
	margin: ${StyleVars.defaultSpacingUnit / 2}px 0px;

	&:first-child {
		margin-top: 0px;
	}

	&:last-child {
		margin-bottom: 0px;
	}
`;
